import { createFileRoute, redirect } from '@tanstack/react-router';

import { AdminPageContent } from '@/features/admin/components/AdminPageContent';
import {
  AdminPageHeader,
  BreadcrumbItemProps,
} from '@/features/admin/components/AdminPageHeader';

const breadcrumbItems: BreadcrumbItemProps[] = [
  {
    label: 'Admin',
    link: { to: '/admin' },
  },
];

export const Route = createFileRoute('/admin/')({
  component: RouteComponent,
  beforeLoad: () => {
    return redirect({
      to: '/admin/qti-test-render',
      search: () => ({ url: '' }),
    });
  },
  ssr: false,
});

function RouteComponent() {
  return (
    <>
      <AdminPageContent>
        <AdminPageHeader breadcrumbItems={breadcrumbItems} />
      </AdminPageContent>
    </>
  );
}
